define('webshopProductsDetailBodyUrlsV1View',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'buttonView',
  'webshopProductsDetailBodyUrlsV1DomainView',
  'template!webshopProductsDetailBodyUrlsV1View',
  'entities/webshop/products'
], function (
  App,
  Module,
  Backbone,
  Marionette,
  _,
  Settings,
  ButtonView,
  DomainView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    className: 'webshop-products-detail-body-urlsv1-view',
    childView: DomainView,
    childViewContainer: '.domains-container',
    childViewOptions: function () {
      return {
        webshopConfig: this.webshopConfig,
        productCode: this.model.getCode()
      };
    },

    initialize: function () {
      this.collection = new Backbone.Collection();
      this.webshopConfig = this.options.webshopConfig;
      this.fetchRequest = null;
    },

    serializeData: function () {
      var data = {};
      var url = Settings.configValue('webshop.url');
      data.adminUrl = url + '/admin/default/jqadm/get/product/' + this.model.getId();
      return data;
    },

    onShow: function () {
      this.fetch();
    },

    fetch: function () {
      this.collection.reset();

      var params = {
        code: this.model.getCode()
      };

      if (this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
        type: 'GET',
        url: App.request('webshop.product.urls', params),
        success: _.bind(function (items) {
          this.collection.add(items);
        }, this)
      });
    }
  });
});
